import { atom } from 'recoil';

export interface Project {
  id: string;
  unique_code: string;
  name: string;
  website?: string;
  twitter?: string;
  telegram?: string;
  contract_address?: string;
  chain?: 'ETH' | 'SOL' | 'BNB' | 'BASE' | 'ARBITRUM' | 'POLYGON' | 'AVALANCHE';
  profile_logo?: string;
  profile_logo_s3_url?: string;
  is_super_project?: boolean;
  features: {
    chat: boolean;
    ai_search: boolean;
    feedback: boolean;
  };
  telegram_group_id?: string;
  created_at?: string;
  updated_at?: string;
  stats?: {
    total_messages: number;
    user_messages: number;
    bot_messages: number;
    human_messages: number;
    total_feedback: number;
    average_rating: number;
    rating_distribution: Record<number, number>;
  };
}

export interface TrainingSet {
  id: string;
  project_id: string;
  question: string;
  answer: string;
  order_index: number;
  created_at: string;
  updated_at: string;
}

export interface CreateProjectData {
  name: string;
  website?: string;
  twitter?: string;
  telegram?: string;
  contract_address?: string;
  chain?: 'ETH' | 'SOL' | 'BNB' | 'BASE' | 'ARBITRUM' | 'POLYGON' | 'AVALANCHE';
  features: {
    chat: boolean;
    ai_search: boolean;
    feedback: boolean;
  };
  telegram_group_id?: string;
  is_super_project?: boolean;
}

export interface UpdateProjectData extends Partial<CreateProjectData> {
  id: string;
}

export const authTokenState = atom<string | null>({
  key: 'authToken',
  default: localStorage.getItem('adminToken'),
});

export const currentProjectState = atom<Project | null>({
  key: 'currentProject',
  default: null,
});

export const trainingSetsState = atom<TrainingSet[]>({
  key: 'trainingSets',
  default: [],
});

